module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    attrs: {
      "id": "subscribe-popup"
    }
  }, [_c('transition', {
    attrs: {
      "name": "popup"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "subscribe-popup__body"
  }, [_c('close-icon', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }), _vm._v(" "), _c('subscribe-form', {
    on: {
      "submit": function($event) {
        _vm.visible = false
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3626c2ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscribePopUp.vue
// module id = 378
// module chunks = 1